export const deleteTask = () => {
  const deleteButton = document.querySelector(`.js-delete-btn`);
  const deleteConfirmModal = document.querySelector(`.js-confirm`);

  if (deleteConfirmModal && deleteButton) {
    const closeButtons = deleteConfirmModal.querySelectorAll(`.js-close`);

    function showConfirmModal() {
      deleteConfirmModal.classList.add(`one-task__delete-modal--show`);
      closeButtons.forEach((closeButton) => {
        closeButton.addEventListener(`click`, hideConfirmModal);
      });
    }

    function hideConfirmModal() {
      deleteConfirmModal.classList.remove(`one-task__delete-modal--show`);
      closeButtons.forEach((closeButton) => {
        closeButton.removeEventListener(`click`, hideConfirmModal);
      });
    }

    deleteButton.addEventListener(`click`, showConfirmModal);
  }
};
